import React from 'react';
import {
    Select,
    TextField,
    Stack,
    Checkbox
} from '@shopify/polaris';

const operatorOptions = [
    { label: 'tag name is', value: 'EqualTo' },
    { label: 'tag name is not', value: 'NotEqualTo' },
    { label: 'tag name contains', value: 'Contains' },
    { label: 'tag name does not contain', value: 'DoesNotContain' },
    { label: 'tag name starts with', value: 'StartsWith' },
    { label: 'tag name does not start with', value: 'DoesNotStartWith' },
    { label: 'tag name ends with', value: 'EndsWith' },
    { label: 'tag name does not end with', value: 'DoesNotEndWith' },
];

const operatorOptions2 = [
    { label: 'equal to', value: 'EqualTo' },
    { label: 'not equal to', value: 'NotEqualTo' },
    { label: 'containing', value: 'Contains' },
    { label: 'not containing', value: 'DoesNotContain' },
    { label: 'starting with', value: 'StartsWith' },
    { label: 'not starting with', value: 'DoesNotStartWith' },
    { label: 'ending with', value: 'EndsWith' },
    { label: 'not ending with', value: 'DoesNotEndWith' },
];

class TagActionComponent extends React.Component {
    state = {

    };

    render() {

        let actionComponent = <Stack alignment="center" spacing="tight">
            <img width="40px" alt="add tag operation" src="https://taggeniemain.blob.core.windows.net/images/single-tag-add-small.png"></img>
            <span>Add tag with name</span>
            <Stack.Item fill>
                <Stack alignment="center" spacing="tight" distribution="leading">
                    <TextField
                        placeholder="Enter tag name"
                        value={this.props.action.tagName}
                        onChange={this.handleTagNameChange} />
                </Stack>
            </Stack.Item>
        </Stack>

        if (this.props.action.type === "rename") {
            actionComponent = <Stack alignment="center" spacing="tight">
                <img width="40px" alt="rename tag operation" src="https://taggeniemain.blob.core.windows.net/images/single-tag-rename-small.png"></img>
                <span>Rename tags where</span>
                <Stack.Item fill>
                    <Stack alignment="center" spacing="tight" distribution="leading">
                        <Select
                            options={operatorOptions}
                            value={this.props.action.filter.operator}
                            onChange={(selected, id) => this.handleConditionOperatorChange(selected)}
                        />
                        {this.getTagValueComponent(this.props.action.filter.operator)}
                        <span>with</span>
                        <TextField
                            placeholder="Enter tag name"
                            value={this.props.action.tagTemplate}
                            onChange={this.handleTagTemplateChange} />
                    </Stack>
                </Stack.Item>
            </Stack>
        }

        if (this.props.action.type === "conditionalAdd") {
            actionComponent = <Stack alignment="center" spacing="tight">
                <img width="40px" alt="add tag operation based on donditions" src="https://taggeniemain.blob.core.windows.net/images/single-tag-add-conditional-small.png"></img>
                <span>Add tag</span>
                <Stack.Item fill>
                    <Stack alignment="center" spacing="tight" distribution="leading">
                        <TextField
                            placeholder="Tag name or template"
                            value={this.props.action.tagTemplate}
                            onChange={this.handleTagTemplateChange} />
                        <span>where product has a tag</span>
                        <Select
                            options={operatorOptions2}
                            value={this.props.action.filter.operator}
                            onChange={(selected, id) => this.handleConditionOperatorChange(selected)}
                        />
                        {this.getTagValueComponent(this.props.action.filter.operator)}
                        {/* <span>with</span> */}
                    </Stack>
                </Stack.Item>
            </Stack>
        }

        if (this.props.action.type === "changePrefix") {
            actionComponent = <Stack alignment="center" spacing="tight">
                <img width="40px" alt="add tag operation based on donditions" src="https://taggeniemain.blob.core.windows.net/images/single-tag-add-conditional-small.png"></img>
                <span>Change prefix</span>
                <Stack.Item fill>
                    <Stack alignment="center" spacing="tight" distribution="leading">
                        <TextField
                            placeholder="Prefix to change"
                            value={this.props.action.originalPrefix}
                            onChange={this.handleOriginalPrefixChange} />
                        <TextField
                            placeholder="New Prefix"
                            value={this.props.action.newPrefix}
                            onChange={this.handleNewPrefixChange} />
                        <Checkbox
                            label="Keep original tags"
                            checked={this.props.action.keepOriginalTags}
                            onChange={this.handleKeepOriginalTagsChange}
                        />
                    </Stack>
                </Stack.Item>
            </Stack>
        }

        if (this.props.action.type === "remove") {
            actionComponent = <Stack alignment="center" spacing="tight">
                <img width="40px" alt="remove tag operation" src="https://taggeniemain.blob.core.windows.net/images/single-tag-remove-small.png"></img>
                <span>Remove tags where</span>
                <Stack.Item fill>
                    <Stack alignment="center" spacing="tight" distribution="leading">
                        <Select
                            options={operatorOptions}
                            value={this.props.action.filter.operator}
                            onChange={(selected, id) => this.handleConditionOperatorChange(selected)}
                        />
                        {this.getTagValueComponent(this.props.action.filter.operator)}
                    </Stack>
                </Stack.Item>
            </Stack>
        }

        return actionComponent;
    }

    getTagValueComponent(condition) {

        let tagSelectItems = [
            { label: "--- Choose tag ---", value: "" },
            ...this.props.tags,
        ];

        return (
            condition === "EqualTo" ?
                <Select
                    options={tagSelectItems}
                    value={this.props.action.filter.value}
                    onChange={(selected, id) => this.handleConditionValueChange(selected)}
                /> :
                <TextField
                    placeholder="Enter value"
                    value={this.props.action.filter.value}
                    onChange={(selected, id) => this.handleConditionValueChange(selected)}
                />
        );
    }

    handleNewPrefixChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.newPrefix = newValue;

        this.props.onActionUpdated(updatedAction);
    }

    handleOriginalPrefixChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.originalPrefix = newValue;

        this.props.onActionUpdated(updatedAction);
    }

    handleKeepOriginalTagsChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.keepOriginalTags = newValue;

        this.props.onActionUpdated(updatedAction);
    }

    handleTagNameChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.tagName = newValue;

        this.props.onActionUpdated(updatedAction);
    }

    handleTagTemplateChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.tagTemplate = newValue;

        this.props.onActionUpdated(updatedAction);
    }

    handleConditionOperatorChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.filter.operator = newValue;

        this.props.onActionUpdated(updatedAction);
    }

    handleConditionValueChange = (newValue) => {
        let updatedAction = JSON.parse(JSON.stringify(this.props.action));
        updatedAction.filter.value = newValue;

        this.props.onActionUpdated(updatedAction);
    }
}

export default TagActionComponent;
